export const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
};

export const isValidHTTPUrl = (url: string) => {
  const normalizedUrl = url.trim();
  if (!normalizedUrl || /\s/.test(normalizedUrl)) return false;

  try {
    const parsedUrl = new URL(normalizedUrl);
    return (
      (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') &&
      parsedUrl.hostname.length > 0 &&
      parsedUrl.hostname !== '.'
    );
  } catch {
    return false;
  }
};

export const isValidWebsocketUrl = (url: string) => {
  try {
    const obj = new URL(url);
    return obj.protocol === 'wss:';
  } catch (err) {
    return false;
  }
};
